import StyleSheet from '../sheet';
import flatten from '../utils/flatten';
import isStaticRules from '../utils/isStaticRules';
import { joinStringArray } from '../utils/joinStrings';
var GlobalStyle = /** @class */ (function () {
    function GlobalStyle(rules, componentId) {
        this.rules = rules;
        this.componentId = componentId;
        this.isStatic = isStaticRules(rules);
        // pre-register the first instance to ensure global styles
        // load before component ones
        StyleSheet.registerId(this.componentId + 1);
    }
    GlobalStyle.prototype.createStyles = function (instance, executionContext, styleSheet, stylis) {
        var flatCSS = joinStringArray(flatten(this.rules, executionContext, styleSheet, stylis));
        var css = stylis(flatCSS, '');
        var id = this.componentId + instance;
        // NOTE: We use the id as a name as well, since these rules never change
        styleSheet.insertRules(id, id, css);
    };
    GlobalStyle.prototype.removeStyles = function (instance, styleSheet) {
        styleSheet.clearRules(this.componentId + instance);
    };
    GlobalStyle.prototype.renderStyles = function (instance, executionContext, styleSheet, stylis) {
        if (instance > 2)
            StyleSheet.registerId(this.componentId + instance);
        // NOTE: Remove old styles, then inject the new ones
        this.removeStyles(instance, styleSheet);
        this.createStyles(instance, executionContext, styleSheet, stylis);
    };
    return GlobalStyle;
}());
export default GlobalStyle;
//# sourceMappingURL=GlobalStyle.js.map